import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaBuyingModalities component.
 */
const FichaBuyingModalities = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-MecanismosDeCompra.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Corresponde al nombre de cada mecanismo de compra que utiliza el organismo comprador.</Item>
        <Item>Número de órdenes de compras realizadas bajo ese mecanismo de compra.</Item>
        <Item>Monto total transado mediante el mecanismo de compra correspondiente.</Item>
        <Item>Escala de montos transados en millones de pesos. (CLP)</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaBuyingModalities
